<template>
  <div>
    <div v-if="typeRegister === 'progress'" class="card-body px-3 py-2">

      <label for="weight" class="label">
        {{ $t( typeStatus === 'progress' ? 'progress_statuses' : 'incident_statuses') }}
      </label>

      <multiselect
        v-model="selectedStatus"
        :options="permittedStatuses"
        :multiple="allowedSelectMultiple"
        :hide-selected="false"
        track-by="name"
        :customLabel="_selectedLabel"
        :show-labels="false"
        :placeholder="$t(placeholder)"
        :disabled="disabled"
        :max-height="180"
        open-direction="top"
        >

        <!-- Template de las opciones -->
        <template slot="option" slot-scope="{ option }">
          <div class="flex items-center space-x-2">
            <span
              class="inline-block w-4 h-4 rounded"
              :style="{ backgroundColor: option.color }"
            ></span>
            <span>{{ option.name }}</span>
          </div>
        </template>

        <template slot="clear" slot-scope="props">
          <div class="multiselect__clear" v-if="statuses.length" @mousedown.prevent.stop="clearAll(props.search)"></div>
        </template>

        <!-- Template del valor seleccionado -->
        <template slot="singleLabel" slot-scope="{ option }">
          <div class="flex items-center space-x-2">
            <span
              class="inline-block w-4 h-4 rounded"
              :style="{ backgroundColor: option.color }"
            ></span>
            <span>{{ option.name }}</span>
          </div>
        </template>

      </multiselect>

      <div class="flex flex-col w-full mt-4">
        <label for="weight" class="label">{{ $t('registration_date') }}</label>
        <div class="flex flex-row">
          <input
            v-model="end_date"
            title="end_date"
            :disabled="false"
            :required="true"
            name="end_date"
            type="date"
            class="w-full h-8 p-1 text-xs border rounded bg-grey-lighter border-grey-light" />
        </div>
      </div>

      <!-- <b-button type="is-primary" expanded @click="_onClickChangeStatus" class="mt-4">{{ $t('apply_status') }}</b-button> -->
    </div>

      <div v-else class="card-body px-3 py-2">
        <label for="weight" class="label">{{ $t('status') }}</label>
        <b-select v-model="selectedStatus"
          :placeholder="$t('select_status')"
          icon="traffic-light"
          icon-pack="fas"
          expanded>
          <option :value="0" key="status_null">{{ $t('without_issue') }}</option>
          <option :value="1" key="status_with_issue">{{ $t('with_issue') }}</option>
        </b-select>

        <!-- <b-button type="is-primary" expanded @click="_onClickChangeStatus" class="mt-4">{{ $t('mark') }}</b-button> -->
      </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import moment from 'moment'

export default {
  name: 'UpdateStatusesForm',

  components: {
    Multiselect
  },

  props: {
    typeRegister: {
      type: String,
      default: 'progress'
    },
    typeStatus: {
      type: String,
      default: 'progress'
    },
    statuses: {
      type: Array,
      default: []
    },
    permittedStatuses: {
      type: Array,
      default: []
    },
    selectedEntities: {
      type: Array,
      default: []
    },
    allowedSelectMultiple: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      start_date: null,
      end_date: moment().format('YYYY-MM-DD'), // Formato requerido para input type="date"

      placeholder: 'select_status',
      disabled: false,

      selectedTypeStatus: 'progress',
      selectedStatus: this.typeRegister === 'progress' ? [] : null,
    }
  },

  computed: {
    hasSelection() {
      if (!this.selectedStatus) return false;
      if (Array.isArray(this.selectedStatus)) return this.selectedStatus.length > 0;
      if (typeof this.selectedStatus === 'object') return Object.keys(this.selectedStatus).length > 0;
      return true;
    }
  },

  methods: {
    _selectedLabel(value) {
      return value.name
    },

    _GetCssColor(value) {
      let s = value.toString(16)
      while (s.length < 6) {
          s = "0" + s
      }
      return "#" + s
    },

    applyStatus() {
      if ( !this.ValidateForm() ) {
        return
      }
      // TODO: conciderar en guardar el estado anterior por si deselecciona luego de que ha cambiado el estado
      // manejar el evento en el lugar que se realiza la deselección del elemento
      const lastSelectedStatus = this.allowedSelectMultiple
          ? this.selectedStatus[this.selectedStatus.length - 1]
          : this.selectedStatus;

      let tempSelectedEntities = this.selectedEntities.filter(el => {
        if (this.typeRegister === 'progress') {
          // Usar el método applyStatus de Pic.js que sincroniza picStatus, picStatusColor y picFillColor
          return el.applyStatus(lastSelectedStatus)
        } else {
          el.setWithIssue(lastSelectedStatus)
          return true // Mantener el elemento
        }
      })


      return {
        typeStatus: this.selectedTypeStatus,
        selectedStatus: this.selectedStatus,
        changeEntities: tempSelectedEntities,
        start_date: this.end_date,
        end_date: this.end_date
      }
    },

    ValidateForm() {
      if ( !this.hasSelection ) {
        this.$toast.open({
          message: this.$t('must_select_status'),
          type: "is-danger",
          position: "is-top-right"
        });
        return false
      }

      if ( !this.end_date ) {
        this.$toast.open({
          message: this.$t('must_select_date'),
          type: "is-danger",
          position: "is-top-right"
        });
        return false
      }

      return true
    },

    ResetForm() {
      this.selectedStatus = this.typeRegister === 'progress' ? [] : null;
      this.start_date = null
      this.end_date = moment().format('YYYY-MM-DD');
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
